import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '分类', href: '/category/all' },
    { label: '排行榜', href: '/category/hot' },
    { label: '关于我们', href: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="text-2xl md:text-3xl font-heading text-primary-500 transition-colors duration-200">
              韩漫屋
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href
                || (link.href !== '/' && location.pathname.startsWith(link.href));
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? 'text-primary-500 bg-primary-50'
                      : scrolled
                        ? 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                        : 'text-foreground-700 hover:text-primary-500 hover:bg-white/20'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-3">
            <button
              className="hidden md:flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              aria-label="开始阅读"
            >
              <i className="ri-book-open-line"></i>
              开始阅读
            </button>

            <button
              className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
              aria-expanded={mobileOpen}
            >
              <i className={`text-xl text-foreground-900 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="flex flex-col p-4 gap-2" aria-label="移动端导航">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href
                || (link.href !== '/' && location.pathname.startsWith(link.href));
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    isActive
                      ? 'text-primary-500 bg-primary-50'
                      : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <button
              className="mt-2 flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-book-open-line"></i>
              开始阅读
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}